import { connect } from 'react-redux';
import HomeAddressDetails from "../../../components/admin/riaContacts/acordionSections/HomeAddressDetails";

const mapStateToProps = (state) => {
  return {
    adminUserSession: state.adminLogin.adminUserSession,
  }
}

const HomeAddressDetailsContainer = connect(mapStateToProps, {})(HomeAddressDetails)

export default HomeAddressDetailsContainer;
